import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import Canvas from "./Canvas";
import Queue from "./Queue";
import History from "./History";
import Bet from "./Bet";
import { Helmet } from "react-helmet";
import BankRoll from "../../Components/Game/BankRoll";
import { wait, Event } from "../../../Helper";
import Help from "./Help";
import Engine from "./Engine";
import Loading from "../Loading";
import BetsPopKeno from "./Graph";

class Game extends React.Component {
  _Mounted = false;
  constructor(props) {
    super(props);
    this.state = {
      engine: new Engine(),
      mobile: false,
      padding: "p-1",
      showPopup: false,
    };
    this.handleResize = this.handleResize.bind(this);
    this.handleShowPopUp = this.handleShowPopUp.bind(this);
  }

  componentDidMount() {
    let { engine } = this.state;

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    // Start Engine
    engine.started = true;

    wait(600).then(() => {
      this._Mounted = true;
      this.handleResize();
    });
    window.addEventListener("resize", this.handleResize);

    if (this.isMobile()) {
      this.setState({ height: "unset", mobile: true });
    } else {
      this.setState({ height: this.getHeight(), mobile: false });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    this._Mounted = false;

    let { engine } = this.state;

    // Stop Engine
    engine.started = false;
    engine.trigger = null;
    engine.off();
  }

  handleResize() {
    if (this.getWidth() < 1540) {
      this.setState({ col: "col-xl-12" });
      Event.emit("hide_games");
    } else {
      this.setState({ col: "col-md-12" });
      Event.emit("show_min_games");
    }

    if (this.isMobile()) {
      this.setState({ mobile: true, ovh: "ovh", padding: "p-0" });
    } else {
      this.setState({ mobile: false });
    }
  }

  handleShowPopUp() {
    this.setState((prevState) => ({
      showPopup: !prevState.showPopup,
    }));
  }

  getHeight() {
    return document.documentElement.clientHeight || document.body.clientHeight;
  }

  getWidth() {
    return document.documentElement.clientWidth || document.body.clientWidth;
  }

  isMobile() {
    return this.getWidth() < 992;
  }

  render() {
    let { engine, col, ovh, padding } = this.state;
    return (
      <>
        <Helmet>
          <title>Keno</title>
          
          <link rel="canonical" href="/keno" />
        </Helmet>
        <div>
          {this._Mounted ? (
            <div
              className={`${col} ${padding}`}
              style={{ position: "relative", width: "100%", height: "100%" }}
            >
              {this.state.showPopup && (
                <BetsPopKeno onClose={this.handleShowPopUp} engine={engine} />
              )}
              <Row className={"animated fadeIn " + ovh}>
                <Col sm={12} className={"m-auto " + col + " " + padding}>
                  {/*history */}

                  <Canvas engine={engine} />

                  <Card style={{ marginTop: "20px" }} className="mb-0">
                    <Card.Body style={{padding:"0px"}}>
                      <Row>
                        <Col sm={12} md={12} className={"text-left m-auto"}>
                          <Bet engine={engine} mobile={this.state.mobile} />
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                  <Card xl={8} className="mb-0 col-xl-8" style={{borderBottomLeftRadius:"10px",borderBottomRightRadius:"10px",backgroundColor:"#17181B",borderTop:"2px solid #1F2125"}}>
                    <Card.Body className="px-2 py-3">
                      <Row>
                        <Col md={6} className={"col-6 text-left"}>
                          <BankRoll game={"keno"} />
                        </Col>
                        <Col  md={3} className={"col-6 text-right"}>
                          <div style={{ display: "flex", gap: "30px"}}>
                            <div style={{   cursor: "pointer",
    marginRight: "0.5rem",
    width: "2.75rem",
    height: "2.75rem",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",}} 
                              onClick={this.handleShowPopUp}
                              
                            >
                              <img
                                style={{ height: "20px", width: "20px" }}
                                src="/assets/images/nanoicons/nanoswap.png"
                                alt="Swap"
                              />
                            </div>{" "}
                            <History engine={engine} />
                            <Help />
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                  <Card style={{ marginTop: "20px" }} className="mb-0"> 
                    <Card.Body className="py-0 px-2">
                      <Queue game={"keno"} engine={engine} t={this.props.t} />
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          ) : (
            <Loading />
          )}
        </div>
      </>
    );
  }
}

export default Game;
